module.exports = __webpack_public_path__ + "img/294bac8.jpg";